import React from 'react';
import PropTypes from 'prop-types';
import { useQuery, useApolloClient } from '@apollo/client';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { GET_USER } from 'store/queries';
import { Spinner } from 'admin-components/components';
import { Row, Column } from 'components/shared/Layout';
import { getLaunchDarklyContext } from 'utils/launchDarkly';

const updateIdentifier = async (ldClient, userIdentifier) => {
  const context = await getLaunchDarklyContext(userIdentifier);
  const currentContext = ldClient.getContext();

  if (context?.key && context.key !== currentContext?.key) {
    ldClient.identify(context);
  }
};

const GetUserQuery = ({ fetchPolicy, children }) => {
  const ldClient = useLDClient();
  const client = useApolloClient();
  const { loading, data } = useQuery(GET_USER, {
    errorPolicy: 'ignore',
    fetchPolicy: fetchPolicy || 'cache-first'
  });

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (data?.me?.username) {
    updateIdentifier(ldClient, data.me.username);
  }

  return children({ data: data || {}, client });
};

GetUserQuery.propTypes = {
  children: PropTypes.func,
  fetchPolicy: PropTypes.string
};

export default GetUserQuery;
